/* eslint-disable jsx-a11y/mouse-events-have-key-events */
/* eslint-disable no-use-before-define */
/* eslint-disable no-new */
/* eslint-disable no-unused-vars */
import { Image, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import cors from 'cors';
import {
    handleProdcutMultipleImage,
    removeGalleryImage,
} from '../../redux/products/productsActions';
import DokanIcons from '../icon/DokanIcons';
import ImageAlt from '../../assets/images/image_alt.svg';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function DokanMultiUpload() {
    const dispatch = useDispatch();
    const [showDismiss, setShowDismiss] = useState(false);
    const { galleryImages } = useSelector((state) => state.products.productInputData);
    const { galleryLoader } = useSelector((state) => state.products);
    // const productImages = galleryImages.length > 1 ? images.slice(1) : [];
    // console.log('productImages', productImages);
    const getBase64 = (file) => {
        const reader = new FileReader();
        const readFile = new Promise((resolve, reject) => {
            // read as file
            reader.readAsDataURL(file);
            // file fully loaded
            reader.onload = (fileEvent) => {
                resolve(fileEvent);
            };
            reader.onerror = (error) => {
                reject(error);
            };
        });
        return readFile;
    };
    const inputFile = () => {
        const input = document.createElement('input');
        console.log(input);
        input.type = 'file';
        input.onchange = (e) => {
            // you can use this method to get file and perform respective operations
            const files = Array.from(input.files);
            onFileChange(files[0]);
        };
        input.click();
    };
    const onFileChange = (fileInput) => {
        const file = fileInput;
        const data = {
            name: '',
            image: '',
        };
        // read file object
        // getBase64(file).then((res) => {
        //     data.name = 'Image';
        //     data.image = res.target.result;
        //     console.log(res, data);
        // });
        const form = new FormData();
        // form.append('productGalleryImage', file, file.name);
        form.append('productGalleryImage', file, file.name);

        // set all images....
        dispatch(handleProdcutMultipleImage(file.name, file));
    };
    const handleGalleryImage = (data) => {
        dispatch(removeGalleryImage(data));
    };
    return (
        <>
            <div className="flex flex-col md:flex-row gap-3 mt-6 flex-wrap">
                <Spin indicator={antIcon} spinning={galleryLoader}>
                    <div className="gallery-image-upload-btn w-13 h-13">
                        <button
                            type="button"
                            className="gallery-upload-btn focus:outline-none hover:bg-gray-100"
                            onClick={inputFile}
                        >
                            <DokanIcons icon="#plus" />
                        </button>
                    </div>
                </Spin>
                {!galleryImages.length ? (
                    <div
                        className="gallery-image-upload-btn w-13 h-13"
                        onMouseOver={() => setShowDismiss(true)}
                        onMouseLeave={() => setShowDismiss(false)}
                    >
                        <img
                            src={ImageAlt}
                            alt={ImageAlt}
                            className="h-full w-full px-3 py-3 bg-white border border-image-box rounded-md  hover:opacity-25"
                        />
                    </div>
                ) : null}
                {galleryImages.map((file, index) => (
                    <div
                        className="gallery-image-box"
                        key={file.id}
                        onMouseOver={() => setShowDismiss(true)}
                        onMouseLeave={() => setShowDismiss(false)}
                    >
                        <img src={file.src} alt={ImageAlt} className="gallery-image" />
                        {showDismiss && (
                            <div className="gallery-image-hover-box">
                                <div className="gallery-dismiss-button">
                                    <button
                                        type="button"
                                        className="focus:outline-none"
                                        onClick={() => {
                                            handleGalleryImage(file);
                                        }}
                                    >
                                        <DokanIcons icon="#cross_oval" size="6" />
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                ))}

                {/** test */}
            </div>
        </>
    );
}

export default DokanMultiUpload;
